import Nav from './Nav';
import Footer from './Footer';

function Privacy() {
  return (
    <div className="App">
      <Nav />

      <main className="main-content">
        <section className="content-section">
          <div className="section-container">
            <h2>Privacy Policy</h2>
            <div className="privacy-content">
              <h3>Data Collection</h3>
              <p>We collect only the information necessary to provide our services. This includes the content you choose to save, your app usage patterns, and basic account information.</p>
              
              <h3>Data Usage</h3>
              <p>Your data is used solely to enhance your Nibblet experience. We analyze usage patterns to improve our offerings, but we never sell your personal information to third parties.</p>
              
              <h3>Data Security</h3>
              <p>We employ industry-standard security measures to protect your data. All data is encrypted in transit and at rest, and we regularly audit our security practices.</p>
              
              <h3>Your Rights</h3>
              <p>You have the right to access, modify, or delete your data at any time. You can delete your account through the app settings.</p>
              
              <h3>Contact Us</h3>
              <p>If you have any questions about this privacy policy or how we handle your data, please contact us at nibbletapp@gmail.com</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Privacy;